import { createUseStyles } from "react-jss";
import { colors } from "../../styles/colors";

const useStyles = createUseStyles((_) => ({
  container: {
    width: "100%",
    minHeight: "var(--app-vh)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    gap: "12px",
    backgroundColor: colors.primary,
    padding: "24px 0",
    boxSizing: "border-box",
  },
  logo: {
    width: "226px",
    height: "130px",
  },
  text: {
    color: colors.WHITE,
    marginTop: "8px",
    marginBottom: "8px",
    textAlign: "center",
  },
  companyName: {
    color: colors.WHITE,
    textAlign: "center",
  },
  subContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    alignItems: "center",
    width: "min(350px, 90vw)",
  },
  buttonContainer: {
    width: "220px",
  },
  /**
   * Lien secondaire sous un bouton principal ("je ne connais pas mon mot de
   * passe"). Volontairement discret mais VISIBLE : c'est la seule sortie de
   * l'ecran pour quelqu'un qui a un compte sans identifiants, et son absence
   * est ce qui transformait cette page en impasse.
   */
  secondaryAction: {
    color: colors.WHITE,
    textAlign: "center",
    cursor: "pointer",
    textDecoration: "underline",
    fontSize: "13px",
    opacity: 0.9,
    "&:hover": { opacity: 1 },
  },
  /** Message d'etat persistant (refus de connexion, code envoye). */
  infoBox: {
    width: "min(350px, 90vw)",
    boxSizing: "border-box",
    padding: "12px 16px",
    borderRadius: "8px",
    backgroundColor: "rgba(255, 255, 255, 0.12)",
    border: "1px solid rgba(255, 255, 255, 0.25)",
  },
  infoText: {
    color: colors.WHITE,
    textAlign: "center",
    margin: 0,
  },
  /** Adresse invitee, affichee en lecture seule au-dessus du formulaire. */
  emailBadge: {
    color: colors.WHITE,
    textAlign: "center",
    fontWeight: 700,
    wordBreak: "break-all",
  },
  successIcon: {
    width: "72px",
    height: "72px",
    borderRadius: "50%",
    backgroundColor: colors.WHITE,
    color: colors.primary,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "40px",
    fontWeight: 700,
    marginBottom: "8px",
  },
}));

export default useStyles;
